import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Heders from "../components/Headers";
import Banner from "../components/Banner";
import Categorys from "../components/Categorys";
import FeatureProducts from "../components/products/FeatureProducts";
import Products from "../components/products/Products";
import Footer from "../components/Footer";
import { get_category, get_products } from "../store/reducers/homeReducer";
import { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
const Home = () => {
  const dispatch = useDispatch();
  const { products, latest_product } = useSelector((state) => state.home);
  // derive lists client-side to ensure correct filters
  const topRated_product = products
    ? products.filter((p) => (p.rating || 0) > 3)
    : [];
  const discount_product = products
    ? products.filter((p) => (p.discount || 0) > 1)
    : [];
  useEffect(() => {
    dispatch(get_products());
  }, [dispatch]);
  const { t } = useContext(LanguageContext);
  return (
    <div className="w-full">
      <Heders />
      <Banner />
      <div className="my-4 max-w-[1440px] mx-auto px-16 sm:px-5 md-lg:px-12 md:px-10">
        <Categorys />
      </div>
      <div className="py-[45px] max-w-[1440px] mx-auto px-16 sm:px-5 md-lg:px-12 md:px-10">
        <FeatureProducts products={products} />
      </div>
      <div className="py-10">
        <div className="max-w-[1440px] mx-auto px-16 sm:px-5 md-lg:px-12 md:px-10 flex flex-wrap">
          <div className="grid w-full grid-cols-3 md-lg:grid-cols-2 md:grid-cols-1 gap-7">
            <div className="overflow-hidden">
              <Products title={t("latestProduct")} products={latest_product} />
            </div>
            <div className="overflow-hidden">
              <Products
                title={t("topRatedProduct")}
                products={topRated_product}
              />
            </div>
            <div className="overflow-hidden">
              <Products
                title={t("discountProduct")}
                products={discount_product}
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
